// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wu-z","tooltipWrapper":"xu-z","icon":"yu-z","tooltip":"zu-z","content":"Au-z"};